import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { UpdateContentData } from '../apis/api.content'
import { useContent } from '../hooks/ApiHooks/useContent'
import { useProfileDayOfContent } from '../hooks/ApiHooks/useProfileDayOfContent'
import styles from './ContentSelect.module.css'

export const ContentSelect = ({
    profileId,
    setChanges,
    setIsDisabled,
}: {
    profileId: string
    setChanges: Dispatch<SetStateAction<UpdateContentData>>
    setIsDisabled: Dispatch<SetStateAction<boolean>>
}) => {
    const { t } = useTranslation('teamManager')
    const { data: sessionsContent, processedContent } = useContent()
    const { content: profileContent } = useProfileDayOfContent(profileId)

    const [selectedContent, setSelectedContent] = useState<{
        contentTitle: string
        contentNumber: number
    }>({
        contentTitle: '',
        contentNumber: 0,
    })

    const isContentChanged = useMemo(
        () => selectedContent.contentNumber !== profileContent?.contentNumber,
        [selectedContent.contentNumber, profileContent?.contentNumber]
    )

    const setChangesHandler = (newContentNumber: number) => {
        setChanges((prev) => ({
            ...prev,
            content: {
                newContentNumber: newContentNumber,
            },
        }))
    }

    const handleDayChange = (option: { value: number; label: number } | null) => {
        if (!option) return

        // Encontrar el contenido original correspondiente al número seleccionado
        const selectedContentInfo = sessionsContent?.find(
            (content) => option.value >= content.from && option.value <= content.to
        )

        setSelectedContent((prev) => ({
            ...prev,
            contentNumber: option.value,
            contentTitle:
                processedContent?.find(({ numberDay }) => numberDay === option.value)
                    ?.contentTitle || '',
        }))

        // Enviar el valor "from" del contenido original
        if (selectedContentInfo) {
            setChangesHandler(selectedContentInfo.from)
        } else {
            setChangesHandler(option.value)
        }
    }

    const options =
        processedContent?.map(({ numberDay }) => ({
            value: numberDay,
            label: numberDay,
        })) || []

    useEffect(() => {
        setSelectedContent({
            contentTitle: profileContent
                ? profileContent.description
                : sessionsContent?.[0]?.title || '',
            contentNumber: profileContent?.contentNumber || sessionsContent?.[0]?.from || 0,
        })
    }, [profileContent, sessionsContent])

    useEffect(() => {
        setIsDisabled(!isContentChanged)
    }, [isContentChanged, setIsDisabled])

    return (
        <div className={styles.inputs}>
            <div className={styles.container}>
                <label>{t('user-options.content-modal-content')}</label>
                <Select
                    options={options}
                    value={options.find(({ value }) => value === selectedContent.contentNumber)}
                    onChange={handleDayChange}
                    className={styles.input}
                />
            </div>
            <div className={styles.container}>
                <label>{t('user-options.content-modal-title')}</label>
                <input
                    type="text"
                    value={selectedContent.contentTitle}
                    readOnly
                    className={styles.input + ' ' + styles.titleInput}
                />
            </div>
        </div>
    )
}
